import axios from "axios";
import { cmsEnv, cmsHeaders } from "../exports/exports";

export const fetchMunicipality = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_locationUrl}/municipality`,
    );
    return response.data;
  } catch (error) {
    console.error("Server Error");
  }
};

export const fetchPolicies = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_cmsUrl}/content-manager/${process.env.REACT_APP_cmsProjectId}/admission-policy`,
      {
        headers: {
          ...cmsHeaders,
          ...cmsEnv,
        },
      },
    );
    return response.data.slice(-1);
  } catch (error) {
    console.error("Server Error");
  }
};
